import React, { Component } from 'react';
import LookupIssues from './LookupIssues';
import NewIssue from "./NewIssue";

class Navbar extends Component {

    constructor() {
        super();

        this.state = {
            active: 'submit',
        };

        this.changeView = this.changeView.bind(this);
    }

    changeView(view) {
        this.setState({ active: view });
    }

    render() {
        return (
            <div className="main_container container">
                <div className="hero"></div>
                <ul className="nav nav-tabs mt-4">
                    <li className="nav-item">
                        <span className={`nav-link px-4 py-2 ${this.state.active === 'submit' ? 'active' : ''}`} onClick={() => this.changeView('submit')}>Submit Issue</span>
                    </li>
                    <li className="nav-item">
                        <span className={`nav-link px-4 py-2 ${this.state.active === 'search' ? 'active' : ''}`} onClick={() => this.changeView('search')}>Search</span>
                    </li>
                </ul>
                <hr className='mt-0 border_bottom' />
                {
                    this.state.active === 'search' ?
                        <div className='lookup_issues'>
                            <LookupIssues></LookupIssues>
                        </div>
                        :
                        <div>
                            <NewIssue></NewIssue>
                        </div>
                }
            </div>
        );
    }
}

export default Navbar;